import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createUpdateReducer } from '@ff-os/pdp-shared-redux/createUpdateReducer';
import { PdpState } from '@ff-os/pdp-shared-redux/store';

type Ui = {
    showProjectIncompatible: boolean;
    isPhotoPrintsWindowOpen: boolean;
};

export const { actions, reducer } = createSlice({
    name: 'general',
    initialState: {
        showProjectIncompatible: false,
        isPhotoPrintsWindowOpen: false
    },
    reducers: {
        overwrite: (state, action: PayloadAction<any>) => {
            return action.payload;
        },
        updateItem: createUpdateReducer<Ui>()
    }
});

export const createUiBindings = () => ({

    createSelector: <T>(selector: (state: Ui) => T) => createSelector(
        (state: PdpState) => state.ui.general as Ui,
        o => selector(o)),

    createUpdateAction: <TKey extends keyof Ui>(key: TKey) =>
        (value: Ui[TKey]) => actions.updateItem({ key, value })
});